export const pricingWebsitePage = `https://www.diolog.com.au/book-a-demo`;
